import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=0718aefe&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0718aefe')) {
      api.createRecord('0718aefe', component.options)
    } else {
      api.reload('0718aefe', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=0718aefe&", function () {
      api.rerender('0718aefe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M3lAfT4xBSux/JS/comp/childrenage.vue"
export default component.exports